import * as React from "react";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { PlusCircle } from "lucide-react";
import AddBenefitForm from "./AddBenefit";

const BenefitFormDialog = ({ editBenefit, open, setOpen, setEdit }) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors flex items-center gap-2 font-medium shadow-sm">
          <PlusCircle className="w-5 h-5" />
          Add Benefit
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-3xl p-0 border-none bg-transparent">
        <AddBenefitForm 
          setEdit={setEdit} 
          editBenefit={editBenefit} 
          onClose={() => {
            setOpen(false);
            setEdit(null);
          }} 
        />
      </DialogContent>
    </Dialog>
  );
};

export default BenefitFormDialog;
